import { Component } from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Container} from 'react-bootstrap';
import NotificationList from './notification-list';
import PageTitle from '../../../common/page-title/index';
import ArrowButton from '../../../common/button-arrow';
import {getNotifications} from '../../../../actions/notifications';

import './styles.css';
import NotificationSearch from './notification-search';

class Notifications extends Component {
  state = {
    event: ''
  };

  handleEventChange = (e) => {
    this.setState({ event: e.target.value });
  };

  handleClear = () => {
    this.setState({
      event: ''
    }, this.handleSearch);
  };

  handleSearch = () => {
    const { dispatch } = this.props;
    const { event } = this.state;

    dispatch(getNotifications(event));
  };
  componentDidMount() {
    this.props.dispatch(getNotifications());
  }

  render() {
    const { event } = this.state;
    return (
      <Container fluid className="notifications">
        <PageTitle>
          Notifications
        </PageTitle>
        <NotificationSearch
          eventValue={event}
          onEventChange={this.handleEventChange}
          onSearch={this.handleSearch}
          onClear={this.handleClear}
        />
        <Link to="/admin/notifications/new">
          <ArrowButton
            arrow={false}
            className="add-notification"
            color="red"
            permissions={{
              action: 'new',
              subjectClass: 'Notification',
            }}
            submit={false}
          >
            Add notification
          </ArrowButton>
        </Link>

        <NotificationList
          fetched={this.props.fetched}
          fetching={this.props.fetching}
          notifications={this.props.notifications}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  notifications: state.notifications.notifications,
  fetched: state.notifications.fetched,
  fetching: state.notifications.fetching,
});

export default connect(mapStateToProps)(Notifications);
